<template>
  <div class="view agent-profile">
    <h1>{{ $t('agent.label.profile') }}</h1>

    <dl class="account-info">
      <dt>{{ $t('agent.profile.company-organization') }}:</dt>
      <dd>{{ activeAgent.company }}</dd>

      <dt>{{ $t('agent.profile.expiration') }}:</dt>
      <dd>{{ model.expiryDate }} ({{ $tc('general.label.day-lowercase', expiryDays, {count: expiryDays}) }})</dd>
    </dl>

    <!-- Note: These alerts styles are global, you can use anywhere. just showing example here -->
    <div class="alerts">
      <!-- <div class="alert-info">{{ $t('alert.info') }}</div> -->
      <!-- <div class="alert-danger">{{ $t('alert.wrong') }}</div> -->
      <div class="alert-success" v-if="updateResponse === UPDATE_SUCCESS">{{ $t('alert.updated') }}</div>
      <div class="alert-warning" v-else-if="updateResponse === UPDATE_ERROR_PASSWORD_NON_MATCH">{{ $t('alert.mismatch-password') }}</div>
      <div class="alert-warning" v-else-if="updateResponse === UPDATE_GENERIC_ERROR">{{ $t('alert.error') }}</div>
    </div>

    <div class="name-container">
      <form-input type="text" :label="$t('form.label.guest.first-name')" icon="name" v-model="model.firstName"/>
      <form-input type="text" :label="$t('form.label.guest.last-name')" v-model="model.lastName"/>
    </div>
    <form-input type="text" :label="$t('general.label.username')" icon="name" readonly="readonly" v-model="model.username"/>
    <form-input type="password" :label="$t('general.label.password')" icon="password" v-model="password1"/>
    <form-input type="password" :label="$t('general.label.confirm-password')" icon="password" v-model="password2"/>
    <form-input type="email" :label="$t('form.label.guest.email')" icon="email" v-model="model.email"/>
    <form-input type="tel" :label="$t('form.label.guest.phone')" icon="phone" v-model="model.phone"/>

    <button class="button-update" @click="onUpdateClicked">{{ $t('general.label.update') }}</button>
  </div>
</template>

<script>

import moment from 'moment';
import Agent from '@/models/Agent';
import FormInput from '@/components/FormInput.vue';

const UPDATE_SUCCESS = 0;
const UPDATE_GENERIC_ERROR = -1;
const UPDATE_ERROR_PASSWORD_NON_MATCH = -2;

export default {
  name: 'AgentProfile',

  data() {
    return {
      activeAgent: Agent.active(),
      model: this.resetAgent(),
      password1: "",
      password2: "",
      updateResponse: "",
      UPDATE_SUCCESS: UPDATE_SUCCESS,
      UPDATE_GENERIC_ERROR: UPDATE_GENERIC_ERROR,
      UPDATE_ERROR_PASSWORD_NON_MATCH: UPDATE_ERROR_PASSWORD_NON_MATCH,
      breadcrumbLabel: this.$t('agent.label.profile')
    }
  },

  components: {
    FormInput
  },

  computed: {
    expiryDays() {
      let expiryDate = moment(this.model.expiryDate);
      let today = moment();

      return expiryDate.diff(today, 'days');
    }
  },

  methods: {
    resetAgent() {
      let model = new Agent(Agent.active());
      model.bookings = undefined; // not need to update profile
      return model;
    },

    onUpdateClicked() {
      Agent.update(this.model, this.password1, this.password2).then(result => {
        this.updateResponse = result.reason;
      });
    }
  }
}
</script>

<style lang="scss">
.view.agent-profile {
  max-width: 510px;

  .account-info {
    margin: 0 0 25px 0;

    dt {
      float: left;
      color: $colorGray;
      margin-right: 10px;
    }
    dd {
      font-weight: 500;
      margin: 0;
    }
  }

  .name-container {
    @include inputs-in-1row;
  }

  // form override style
  .component.form-input {
    @include form-layout-wide;
  }

  .name .icon { @include font-awesome($fa-var-user, light); }
  .password .icon { @include font-awesome($fa-var-lock-alt, light); }
  .email .icon { @include font-awesome($fa-var-envelope, light); }
  .phone .icon { @include font-awesome($fa-var-mobile-alt, light); }

  .button-update {
    @include button($colorCTA, #fff);
    width: 100%;
  }

}
</style>